{
  "app": {
    "name": "Audigoal",
    "tagline": "Learn music. Play for real."
  },
  "common": {
    "continue": "Continue",
    "back": "Back",
    "skip": "Skip",
    "cancel": "Cancel",
    "close": "Close",
    "retry": "Try again",
    "loading": "Loading",
    "start": "Start",
    "done": "Done",
    "save": "Save",
    "settings": "Settings"
  },
  "nav": {
    "learn": "Learn",
    "practice": "Practice",
    "songs": "Songs",
    "ensemble": "Ensemble",
    "profile": "Profile"
  },
  "topbar": {
    "streak": "{n} day streak",
    "picks": "{n} Picks",
    "switchInstrument": "Active instrument: {name}. Tap to switch.",
    "switchTitle": "Which instrument?",
    "switchHint": "This changes your path, your studio and what the microphone listens for. Your progress on every instrument is kept.",
    "manageInstruments": "Add or remove instruments"
  },
  "instrument": {
    "ukulele": "Ukulele",
    "guitar": "Guitar",
    "ocarina": "Ocarina",
    "piano": "Piano",
    "voice": "Voice"
  },
  "welcome": {
    "slide1Title": "Learn to read, hear and understand music",
    "slide1Body": "Exercises are generated fresh every time, so no two lessons are the same.",
    "slide2Title": "Play your ukulele, guitar or ocarina",
    "slide2Body": "Turn on the microphone and the app listens to what you actually play.",
    "slide3Title": "Keep the streak going",
    "slide3Body": "Daily goals, quests and your ensemble to keep you coming back.",
    "getStarted": "Get started",
    "haveAccount": "I already have an account",
    "goToSlide": "Go to slide {n} of {total}"
  },
  "onboarding": {
    "instrumentTitle": "What do you want to play?",
    "instrumentBody": "Pick as many as you like. Tap the star to choose the one you'll practice most.",
    "instrumentPrimary": "Make {name} your main instrument",
    "instrumentIsPrimary": "{name} is your main instrument",
    "theoryOnly": "Just theory for now",
    "theoryOnlyBody": "No instrument lessons. You can add one later in Settings.",
    "goalTitle": "Pick a daily goal",
    "goalBody": "You can change this whenever you like.",
    "goalMinutes": "about {n} min a day",
    "goalCoach": "Tempo says: a goal you actually hit beats a goal that looks impressive.",
    "experienceTitle": "How much music theory do you know?",
    "experienceNew": "Brand new",
    "experienceNewBody": "Start from the very first note.",
    "experienceSome": "I know some",
    "experienceSomeBody": "Take a short test and skip what you already know.",
    "experienceLots": "I know a lot",
    "experienceLotsBody": "Start the test higher up.",
    "ageTitle": "What year were you born?",
    "ageBody": "This sets up the right experience for your age. We don't store the date.",
    "ageYear": "Birth year",
    "agePick": "Choose a year",
    "minorTitle": "A quieter version for you",
    "minorBody": "Ensembles, friends and public profiles are turned off, and nothing about you is tracked. Everything you learn stays exactly the same.",
    "companionTitle": "Choose your companion",
    "companionBody": "They'll cheer you on, explain things and pop up when you need them.",
    "companionSuggested": "Suggested for {instrument}",
    "companionPick": "Choose {name}",
    "micTitle": "Let the app hear you play",
    "micBody": "Volt listens through your microphone and tells you if the note landed. Nothing is recorded or uploaded.",
    "micFallback": "You can always tap your answer instead. Nothing is ever held against you for it.",
    "micEnable": "Enable microphone",
    "micLater": "Maybe later",
    "micBlocked": "Your browser said no. You can turn the microphone on later in Settings.",
    "soundsTitle": "Download sounds for offline?",
    "soundsBody": "Real instrument samples, about 6 MB. Without them the app uses built-in tones.",
    "soundsYes": "Download now",
    "soundsNo": "Not now",
    "stepOf": "Step {n} of {total}",
    "finish": "Start learning",
    "startTest": "Take the test",
    "saved": "Your progress is saved from here on, even before you make an account."
  },
  "testOut": {
    "title": "Test out of {title}",
    "intro": "Read the cards, know the material? Show me, and the whole section is yours.",
    "rule": "{n} questions from across the section. {pass} right and you pass.",
    "prize": "Passing crowns all {n} lessons in the section at once.",
    "noCost": "Getting it wrong costs nothing. You can take it again whenever you like.",
    "start": "Start the test",
    "notNow": "Not now",
    "marking": "Marking your test…",
    "score": "{n} of {total} right",
    "passedTitle": "Passed",
    "passedBody": "{n} lessons are yours. Their skills are set to come back for review soon, so nothing is lost.",
    "failedTitle": "Not this time",
    "failedBody": "You needed {pass}. Nothing has changed, and the lessons are all still there to work through.",
    "readAgain": "Read the cards again",
    "toPath": "Back to the path",
    "notFound": "That section does not exist",
    "failed": "The test could not be built",
    "offer": "Test out of this section",
    "offerUnit": "Test out of this unit",
    "lockedTitle": "Read the section first",
    "lockedBody": "Testing out is for material you have already been through. You have read {n} of the {total} cards in this section.",
    "readTheCards": "Read the cards",
    "alreadyDoneTitle": "You have done this section",
    "alreadyDoneBody": "Every lesson here is already crowned, so there is nothing to test out of.",
    "offerLocked": "Read all {total} cards to test out of this section",
    "offerProgress": "{n} of {total} cards read"
  },
  "learn": {
    "title": "Learn",
    "placeholder": "Your path appears here once the curriculum is wired up in Phase 3.",
    "level": "Level {n}",
    "dailyGoal": "Daily goal, {n} of {total} XP",
    "dueToday": "skills are due for review",
    "section": "Section {n}",
    "sectionProgress": "{n} of {total} crowns",
    "guidebookFor": "Guidebook for {unit}",
    "moreSections": "More sections arrive as the curriculum grows"
  },
  "practice": {
    "title": "Practice",
    "placeholder": "Practice modes arrive in Phase 3.",
    "subtitle": "Sharpen what you have already met.",
    "mistakes": "Mistakes",
    "mistakesBody": "The questions you have got wrong, asked again",
    "due": "Due today",
    "dueBody": "Skills the scheduler says are ready for review",
    "weak": "Weak skills",
    "weakBody": "Whatever is holding up least well",
    "ear": "Ear gym",
    "earBody": "Listening only, with Luna",
    "rhythm": "Rhythm room",
    "rhythmBody": "Counting and tapping, with Tempo",
    "speed": "Speed round",
    "speedBody": "Quick-fire naming against the clock",
    "nothingYet": "Finish a lesson first",
    "studioSoon": "The instrument studio, custom drills and saved presets arrive with the instrument tracks.",
    "studioBody": "Tools for your instrument: tuner, chord changes, scales and more.",
    "speedScore": "Score",
    "speedBest": "A new personal best.",
    "speedToBeat": "Your best is {n}.",
    "speedTime": "{n}s left",
    "earSubModes": "Ear gym",
    "speedRounds": "Speed round",
    "leaderboard": "Your best scores",
    "noScoreYet": "No score yet",
    "skillsInPool": "{n} skills"
  },
  "songs": {
    "title": "Songs",
    "search": "Search songs",
    "instrument": "Instrument",
    "none": "No songs here yet",
    "noneBody": "Try another filter, or another instrument.",
    "notFound": "That song is not in the book",
    "backToSongbook": "Back to the songbook",
    "ahead": "Ahead on your path",
    "masteredShort": "Mastered",
    "mastered": "Mastered — three stars at full tempo with no hints.",
    "meter": "{beats}/{unit}",
    "levelsLabel": "{n} levels",
    "starsLabel": "{n} of 3 stars",
    "filter": {
      "all": "All",
      "continue": "Continue",
      "new": "New",
      "mastered": "Mastered"
    },
    "tag": {
      "beginner": "Beginner",
      "folk": "Folk",
      "hawaiian": "Hawaiian",
      "jazz-age": "Jazz age",
      "classical": "Classical",
      "holiday": "Holiday",
      "world": "World",
      "spiritual": "Spiritual",
      "ragtime": "Ragtime"
    },
    "level": {
      "easy": "Easy",
      "medium": "Medium",
      "hard": "Hard"
    },
    "arrangement": "Arrangement",
    "notOnInstrument": "This song does not fit the {instrument} yet.",
    "play": "Play",
    "playAgain": "Play again",
    "pause": "Pause",
    "resume": "Resume",
    "restart": "Start over",
    "tap": "Tap the beat instead",
    "practiceSections": "Practice a section",
    "listen": "Listen",
    "stopListening": "Stop",
    "duet": "Duet",
    "chordsUsed": "Chords in this song",
    "pdNote": "Public domain. Melody by {composer}; the arrangement is Audigoal's own.",
    "fitYes": "Fits your alto C ocarina as written.",
    "fitOctave": "Played {n} octave(s) from the written pitch to fit your ocarina.",
    "fitTransposed": "Arranged {n} semitones up so it fits your ocarina.",
    "fitNo": "Does not fit the ocarina at any octave.",
    "bar": "Bar {n} of {total}",
    "combo": "{n} in a row",
    "getReady": "Get ready…",
    "waitingFor": "Waiting for",
    "nowPlaying": "Now",
    "fretHint": "string {string}, fret {fret}",
    "tapModeOn": "Tap mode: tap the beat and the app plays along with you.",
    "tapModeOnly": "The microphone is off, so tap the beat instead. Turn it on in Settings to be heard.",
    "tempo": "Tempo",
    "waitMode": "Wait for me",
    "waitModeBand": "In wait mode the band sits out: it cannot pause mid-bar. The guide still plays each note you are waiting on.",
    "hints": "Hints",
    "useMic": "Listen",
    "notationLabel": "Notation",
    "notation": {
      "staff": "Staff",
      "tab": "Tab",
      "chords": "Chords"
    },
    "loop": "Loop",
    "loopBars": "Bars {from}–{to}",
    "loopFrom": "From bar",
    "loopTo": "To bar",
    "loopSet": "Loop these bars",
    "loopClear": "Stop looping",
    "mixer": "Mixer",
    "mix": {
      "chords": "Chords",
      "bass": "Bass",
      "drums": "Drums",
      "guide": "Melody guide",
      "metronome": "Metronome"
    },
    "countIn": "Count-in",
    "duetMelody": "App plays the tune",
    "transposed": "Moved {n} semitones from the original so it fits your instrument.",
    "judgement": {
      "perfect": "Perfect",
      "good": "Good",
      "ok": "OK",
      "miss": "Miss"
    },
    "summary": "Best run of {combo}; {wrong} extra notes.",
    "upFrom": "Up from {n}%.",
    "cappedToday": "You have earned today's song XP — play for fun!",
    "timingOff": "Timing feels off? Calibrate the microphone.",
    "backToPath": "Back to the path"
  },
  "ensemble": {
    "title": "Ensemble",
    "rule": "The people you follow are your ensemble. Every week you share one set: {n} XP for each member. Play it together and everyone collects {picks} Picks.",
    "endsIn": "Week ends in {time}",
    "setTitle": "This week's set · {n} member(s)",
    "setLabel": "{n} of {total} XP played",
    "toGo": "{n} XP to go. Every lesson, song and drill counts.",
    "claim": "Collect {n} Picks",
    "claimed": "+{n} Picks. The set is played.",
    "claimFailed": "Could not collect: {why}",
    "setPlayedClaimed": "Set played — collected for this week.",
    "membersLabel": "Ensemble members",
    "you": "You",
    "level": "Lv {n}",
    "memberXp": "{n} XP",
    "soloTitle": "An ensemble of one",
    "soloBody": "Follow a friend and the set becomes something you play together.",
    "findFriends": "Find friends",
    "minorTitle": "Ensembles are off for this account",
    "minorBody": "Social features are not available on accounts for under-14s. Everything you learn stays exactly the same.",
    "offline": "No connection",
    "offlineBody": "Ensembles need the network. Everything else works offline."
  },
  "profile": {
    "title": "Profile",
    "signedInAs": "Signed in as {name}",
    "anonymous": "Guest",
    "createAccount": "Create an account",
    "signOut": "Sign out",
    "signedOut": "Signed out",
    "keepProgress": "Keep your progress if you change device.",
    "deviceOnly": "No backend is configured, so progress stays on this device.",
    "levelLine": "Level {n} · {xp} XP",
    "toNextLevel": "{n} XP to the next level",
    "streak": "Day streak",
    "gems": "Picks",
    "skillsMastered": "Skills mastered",
    "songsMastered": "Songs at 3 stars",
    "share": "Share your card",
    "cardSaved": "Card saved to your downloads",
    "shareFailed": "Could not make the card: {why}",
    "bonds": "Who you have been practicing with",
    "bondOf": "{name}, bond level {n}",
    "bondLevel": "Lv {n}",
    "achievements": "Achievements",
    "tiersEarned": "{n} tier(s) earned",
    "wardrobe": "Wardrobe",
    "songbook": "Songbook",
    "streakDetail": "Streak",
    "shop": "Shop",
    "quests": "Quests"
  },
  "auth": {
    "signIn": "Sign in",
    "signUp": "Create account",
    "email": "Email",
    "password": "Password",
    "signInCta": "Sign in",
    "signUpCta": "Create account",
    "keepProgress": "Your progress on this device will be kept.",
    "noAccount": "No account yet?",
    "haveAccount": "Already have an account?",
    "errorGeneric": "That did not work. Check your details and try again."
  },
  "settings": {
    "title": "Settings",
    "appearance": "Appearance",
    "theme": "Theme",
    "themeSystem": "Match system",
    "themeLight": "Light",
    "themeDark": "Dark",
    "reduceMotion": "Reduce motion",
    "reduceMotionHelp": "Turn off springs, confetti and screen wipes.",
    "account": "Account",
    "about": "About",
    "instrument": "Instrument",
    "primaryInstrument": "Primary instrument",
    "primaryInstrumentHelp": "The path weaves in this instrument’s track units. Theory progress is shared between instruments.",
    "sound": "Sound",
    "noteNames": "Note names",
    "namingEnglish": "A B C",
    "namingSolfege": "Do re mi",
    "namingGerman": "German",
    "mute": "Mute everything",
    "muteHelp": "Silences music, effects and the metronome.",
    "haptics": "Vibration",
    "hapticsHelp": "A short buzz on answers and milestones.",
    "describeAudio": "Describe sounds in text",
    "describeAudioHelp": "Prints what an audio prompt contains, for screen readers.",
    "microphone": "Microphone",
    "micLatency": "Microphone delay",
    "micLatencyHelp": "How long your device takes to hear what it plays. Rhythm exercises correct for it.",
    "calibrate": "Measure it for me",
    "calibrateDone": "Measured {ms} ms and saved it.",
    "calibrateUnsure": "Got about {ms} ms, but the readings disagreed. Try somewhere quieter, or set it by hand.",
    "calibrateNothing": "I did not hear the clicks. Turn the volume up, or take headphones off, and try again.",
    "micInput": "Input",
    "micInputDefault": "System default",
    "micInputUnnamed": "Unnamed input",
    "notifications": {
      "title": "Notifications",
      "body": "All off unless you ask. You choose which, and when.",
      "unsupported": "This browser cannot show notifications.",
      "deniedBody": "Your browser has blocked notifications for this site. You can allow them in its site settings.",
      "deniedNative": "Notifications are off for Audigoal in your phone’s settings. Turn them on there and come back.",
      "blocked": "Your browser said no. Nothing else changes.",
      "dailyReminder": "Daily reminder",
      "dailyReminderHelp": "A nudge at your chosen hour, only if you have not played.",
      "streakAtRisk": "Streak at risk",
      "streakAtRiskHelp": "At nine in the evening, when a streak of three or more is about to lapse.",
      "questProgress": "Quest nearly done",
      "questProgressHelp": "When a session leaves a quest within reach.",
      "hour": "Reminder hour",
      "hourHelp": "The time of day a daily nudge would arrive.",
      "turnOff": "No daily reminder"
    },
    "practiceData": "Practice data",
    "practiceDataHelp": "Saves a file of how the exercises have behaved: which generator, at which difficulty, right or wrong, and how long it took. No answers and nothing about what you played.",
    "exportPracticeData": "Save practice data",
    "practiceDataSaved": "Saved {n} attempts.",
    "practiceDataFailed": "The file could not be saved.",
    "accountUsername": "Username",
    "accountUsernameHelp": "Lowercase letters, numbers and underscores, 3 to 20 characters. Friends and your ensemble show it.",
    "accountUsernameCurrent": "You are @{name}.",
    "accountUsernameSave": "Save username",
    "accountUsernameSaved": "You are @{name} now.",
    "accountUsernameTaken": "That one is taken.",
    "accountUsernameInvalid": "Lowercase letters, numbers and underscores only, 3 to 20 characters.",
    "accountUsernameOffline": "Usernames need an account; this build has no backend.",
    "accountSignedInAs": "Signed in as {email}.",
    "accountGuest": "You are using Audigoal as a guest. Progress is saved on this device.",
    "accountCreate": "Create an account",
    "privacy": "Privacy & data",
    "dataExport": "Download my data",
    "dataExportHelp": "Everything Audigoal holds about you, as one JSON file: profile, progress, attempts, scores, purchases.",
    "dataExported": "Saved {n} records.",
    "deleteAccount": "Delete my account",
    "deleteAccountHelp": "Removes your account and everything in it, on the server and on this device. There is no undo.",
    "deleteLocalHelp": "Removes everything saved on this device. There is no undo.",
    "deleteConfirmTitle": "Delete everything?",
    "deleteConfirmBody": "Your progress, streak, Picks, songs and certificate go with it. Type DELETE to confirm.",
    "deleteConfirmAction": "Delete my account",
    "deleteFailed": "The account could not be deleted. Check your connection and try again.",
    "analytics": "Share anonymous usage data",
    "analyticsHelp": "Which screens and exercise types get used, so difficulty can be tuned. Never what you play, never your microphone. Off until you say yes.",
    "errorReports": "Send crash reports",
    "errorReportsHelp": "When something breaks, the error and the screen it happened on. No audio, no answers.",
    "privacyPolicy": "Privacy policy",
    "credits": "Credits & licenses",
    "reportProblem": "Report a problem"
  },
  "error": {
    "title": "Something broke",
    "body": "That screen hit an error. You can go back to the path and keep learning.",
    "goHome": "Back to Learn",
    "notFoundTitle": "Nothing here",
    "notFoundBody": "That page does not exist.",
    "offline": "Offline — progress will sync when you reconnect."
  },
  "a11y": {
    "mainContent": "Main content",
    "primaryNav": "Primary",
    "themeToggle": "Toggle dark mode"
  },
  "audio": {
    "tapToEnable": "Tap to turn on sound",
    "unavailable": "Sound is not available on this device",
    "play": "Play",
    "replay": "Play again",
    "slow": "Slow",
    "describe": "Describe the sound",
    "replaysLeft": "{n} plays left"
  },
  "lesson": {
    "combo": "{n} in a row",
    "countIn": "Starting in {n}",
    "gotIt": "Got it",
    "check": "Check",
    "continue": "Continue",
    "skip": "I don't know",
    "correct": "Correct",
    "wrong": "Not quite",
    "correctAnswer": "The answer is",
    "why": "Why?",
    "hearIt": "Hear it",
    "reviewConcept": "Review this concept",
    "reportProblem": "Report a problem",
    "quit": "Leave the lesson?",
    "quitBody": "Progress in this lesson is lost. The XP you have already earned is not.",
    "quitConfirm": "Leave",
    "quitStay": "Keep going",
    "progress": "Question {n} of {total}",
    "timeLeft": "{n} seconds left",
    "showMe": "Show me",
    "answerByTapping": "Answer by tapping instead",
    "yourAnswer": "Your answer",
    "tapInOrder": "Tap the items in order",
    "availableItems": "Available items",
    "correctOrder": "Correct order",
    "matchPairs": "Match each item to its pair",
    "tapOneKey": "Tap one key",
    "tapKeys": "Tap up to {n} keys",
    "anyPositionAccepted": "Any position of that pitch counts",
    "tapHoles": "Tap a hole to cover it, again to open it",
    "string": "String",
    "tunerTapAsTuned": "Tune by ear, or with the Tuner from the top bar, and tap each string as it comes good.",
    "tapStaff": "Tap a line or space to place the note",
    "accidental": "Accidental",
    "undo": "Undo",
    "placeNotes": "Tap the staff to place each note",
    "placePitches": "The rhythm is given; place the pitches",
    "yourMeasure": "Your measure",
    "tapValues": "Tap note values to fill the measure",
    "beatsFilled": "{n} of {total} beats",
    "measureTooFull": "That is more than the measure holds",
    "noteValues": "Note values",
    "expectedPattern": "Expected",
    "typeAnswer": "Tap to build your answer",
    "accepted": "Accepted",
    "backspace": "Delete",
    "tapNow": "Tap the rhythm",
    "startRhythm": "Start",
    "tapResult": "{perfect} of {total} on the beat",
    "extraTaps": "{n} extra taps",
    "micPhaseNotice": "Tap your answer whenever you would rather not play. Nothing counts against you for it.",
    "notFound": "That lesson does not exist",
    "backToPath": "Back to the path"
  },
  "guidebook": {
    "onYourInstrument": "On your instrument",
    "commonMistakes": "Common mistakes",
    "notFound": "That unit does not exist",
    "empty": "No cards here yet",
    "emptyBody": "This unit’s concept cards arrive with its content.",
    "mastery": "Mastery {n} per cent",
    "masteryLegend": "The dots show how well you know each card, not how many cards there are.",
    "masteryScale": "{word} · {n}%",
    "mastery0": "New",
    "mastery1": "Started",
    "mastery2": "Learning",
    "mastery3": "Known",
    "mastery4": "Strong",
    "practiceUnit": "Practice this unit",
    "cardOf": "Card {n} of {total}",
    "readerNav": "Move through this unit's cards",
    "backToCards": "Back to the unit's cards",
    "nextCard": "Next: {title}",
    "previousCard": "Previous card",
    "readAllPractice": "That's the unit — practice it"
  },
  "complete": {
    "done": "Lesson complete!",
    "perfect": "Flawless!",
    "perfectStamp": "Perfect",
    "xp": "XP",
    "accuracy": "Accuracy",
    "time": "Time",
    "combo": "Best combo",
    "crown": "Crown earned",
    "reviewMistakes": "Review mistakes",
    "nextLesson": "Next: {title}",
    "tryAgain": "Not a crown yet — try it again"
  },
  "path": {
    "locked": "Locked",
    "lockedBody": "Finish the node before this one to unlock it.",
    "notStarted": "Not started",
    "crowns": "{n} crowns earned",
    "crownLevel": "Crowns",
    "kind": "Type",
    "kindLesson": "Lesson",
    "kindReview": "Unit review",
    "kindCheckpoint": "Checkpoint",
    "kindListening": "Listening",
    "kindSong": "Song",
    "kindMicLab": "Mic lab",
    "kindLegendary": "Legendary",
    "requiresMic": "Uses the microphone, with a tap fallback.",
    "start": "Start",
    "practice": "Practice"
  },
  "placement": {
    "title": "Placement test",
    "intro": "A few questions to find where you should start. Nothing counts against you.",
    "introFrom": "We'll begin around Section {n}.",
    "start": "Begin",
    "sectionStep": "Section {n}",
    "stepOf": "Round {n}",
    "checking": "Working out where you fit…",
    "resultTitle": "You're starting at Section {n}",
    "resultZeroTitle": "You're starting at the beginning",
    "resultBody": "Everything below is unlocked and marked as review, so it'll come back now and then to stay fresh.",
    "resultZeroBody": "Nothing to skip — that's the best way to build the foundations properly.",
    "resultUnlocked": "{n} skills unlocked",
    "toPath": "Go to my path",
    "skip": "Skip the test",
    "failed": "The test could not be built. You can start from the beginning instead."
  },
  "mic": {
    "listening": "Listening…",
    "notListening": "Not listening",
    "asking": "Asking for the microphone…",
    "playNow": "Play it when you're ready",
    "inTune": "{note}, in tune",
    "offBy": "{note}, {cents} cents {direction}",
    "flat": "flat",
    "sharp": "sharp",
    "levelLabel": "Input level {n} percent",
    "progressLabel": "Progress through the notes",
    "showMe": "Show me",
    "startListening": "Start listening",
    "startListeningBody": "The microphone opens when you tap. Nothing is recorded.",
    "listenAgain": "Listen again",
    "readyToPlay": "Ready when you are",
    "tapInstead": "Tap the answer instead",
    "cannotListen": "I can't listen right now",
    "deniedBody": "The microphone was turned down. You can answer by tapping, and turn it on later in Settings.",
    "unavailableBody": "No microphone was found. You can answer by tapping.",
    "cannotHearYou": "I can't hear your instrument",
    "cannotHearYouTips": "Move a little closer, play a bit louder, or check the right input is selected in Settings.",
    "tunerTitle": "Tuner",
    "tunerBody": "Play each string on its own. Turn the peg until the needle sits in the middle.",
    "tunerDone": "In tune",
    "tunerAllDone": "Every string is in tune",
    "tunerStart": "Start listening",
    "tunerString": "{note} string",
    "enable": "Enable microphone",
    "startFailed": "The microphone could not start",
    "startFailedBody": "Something went wrong setting up audio. Reloading usually fixes it."
  },
  "tuner": {
    "noStrings": "The {instrument} has no strings to tune.",
    "stringsLabel": "Strings",
    "waiting": "Play it",
    "privacy": "Audio is analyzed on your device and never recorded or uploaded."
  },
  "studio": {
    "title": "Studio",
    "dailyXp": "Studio XP today",
    "dailyXpLabel": "{n} of {total} studio XP earned today",
    "dailyXpHelp": "Studios keep paying out up to this much a day. Lessons are not capped.",
    "micOff": "The microphone is off, so the listening tools will ask you to tap instead. You can turn it on in Settings.",
    "needsMic": "Uses the microphone",
    "done": "Nice work",
    "again": "Go again",
    "backToStudio": "Back to the studio",
    "cappedToday": "No more XP today — but the practice still counts",
    "cappedSome": "You have hit today's studio cap, so this was worth less than usual.",
    "start": "Start",
    "open": "Open",
    "stop": "Stop",
    "play": "Play",
    "nothingToPlay": "There is nothing to play here for your instrument yet.",
    "frettedOnly": "This one is for the ukulele and guitar. Your instrument is the {instrument}.",
    "drillHeadline": "{n} of {total}",
    "drillProgress": "Target {n} of {total}",
    "tappedNote": "No problem — tap it and move on.",
    "skipTarget": "Skip this one",
    "chordA": "First chord",
    "chordB": "Second chord",
    "startRound": "Start the 60 seconds",
    "stopEarly": "Stop",
    "pickTwo": "Pick two different chords.",
    "changesSoFar": "clean changes",
    "changesHeadline": "{n} clean changes",
    "changesDetail": "Between {a} and {b}.",
    "tierFirst": "First four",
    "tierCommon": "Common",
    "tierAll": "Everything",
    "howMany": "How many chords",
    "chordList": "Chords",
    "pickAChord": "Pick a chord to see its shape and its notes.",
    "hearIt": "Hear it",
    "findThisNote": "Find this note",
    "fretboardLabel": "Fretboard",
    "stringFret": "String {string}, fret {fret}",
    "flashHeadline": "{n} of {total} right",
    "startStrum": "Start strumming",
    "tempo": "Tempo",
    "strumHelp": "Four steady strums a bar. Two clean bars and the tempo nudges up.",
    "strumHeadline": "{n} of {total} bars in time",
    "pickScale": "Which scale",
    "runScale": "Run it",
    "scaleRunnerHelp": "Up an octave and back down. Play each note clearly.",
    "scaleHeadline": "{n} of {total} notes",
    "scalePerfect": "Every note. Try it faster next time.",
    "scaleAgain": "Worth another run.",
    "leapsHelp": "The same low note, then one further away each time.",
    "leapsHeadline": "{n} of {total} leaps",
    "holdFor": "Hold each note for",
    "startBreath": "Start",
    "breathHelp": "Steady air, steady note. The needle should not wander.",
    "breathHeadline": "{n} of {total} held for {seconds} seconds",
    "noSuchNote": "No note has that fingering",
    "tapToSee": "Tap to see the fingering",
    "unverifiedFingering": "Not yet confirmed on a real instrument — check it by ear.",
    "unverifiedShort": "Unconfirmed",
    "howLong": "How long",
    "bars": "{n} bars",
    "startReading": "Show me the music",
    "sightHelp": "You get one look. Play it as you read it.",
    "sightHeadline": "{n} of {total} notes read",
    "progression": "Progression",
    "style": "Style",
    "style.strum-island": "Island",
    "style.strum-folk": "Folk",
    "style.arpeggio": "Arpeggio",
    "style.swing-comp": "Swing",
    "warmUpIntro": "About {n} minutes, built from what your instrument needs most.",
    "warmUpEmpty": "Nothing to warm up with yet — turn the microphone on for the full routine.",
    "unknownTool": "No such studio tool",
    "looperHow": "Pick a song. It opens looping its first two bars; move the loop and the tempo from there.",
    "duetHow": "Pick a song. The app takes the other part while you play yours; swap roles from the mixer."
  },
  "calibration": {
    "title": "Tune the app to you",
    "intro": "Every room, microphone and instrument sounds different. Play me a few things and I'll set myself up for yours, rather than guessing.",
    "whatItAsks": "I'll ask you to:",
    "takesAbout": "About {n} minute, once.",
    "privacy": "Everything is measured on your device as you play. No audio is recorded, stored or uploaded.",
    "start": "Let's do it",
    "later": "Maybe later",
    "stepOf": "Step {n} of {total}",
    "stayQuiet": "Nothing to play — just sit still.",
    "keepPlaying": "Keep going until the timer runs out.",
    "hearIt": "Hear it first",
    "nextStep": "Done — next",
    "skipStep": "Skip this one",
    "working": "Working out what I heard…",
    "doneIntro": "All set. Here's what I found.",
    "nothingLearned": "I did not hear enough to change anything, so I have kept the standard settings. You can try again any time.",
    "again": "Measure again",
    "noMicTitle": "No microphone, no problem",
    "noMicBody": "Calibration needs to hear you. Everything still works by tapping, and you can calibrate later from Settings.",
    "settingsTitle": "Calibration",
    "settingsNever": "Not calibrated yet on this device. A minute of playing makes listening noticeably better.",
    "settingsDone": "Calibrated for your {instrument} on this device.",
    "settingsRun": "Calibrate",
    "settingsRedo": "Measure again",
    "onboardingTitle": "One last thing"
  },
  "listening": {
    "kicker": "Listening lesson",
    "intro": "Let's listen to “{title}” all the way through first. Then I'll ask you about what you heard.",
    "play": "Play the piece",
    "playAgain": "Hear it again",
    "stop": "Stop",
    "startQuestions": "On to the questions",
    "listenFirst": "Listen once through before the questions."
  },
  "quests": {
    "title": "Quests",
    "intro": "{done} of {total} done today. Finish all three for a bonus.",
    "allDone": "All three done. That is the day — anything else is for the love of it.",
    "resetsAt": "New quests in {time}",
    "claim": "Claim",
    "claimed": "+{gems} Picks",
    "claimedWithBonus": "+{gems} Picks, and +{bonus} for all three",
    "claimedAlready": "Claimed",
    "claimFailed": "Could not claim: {why}",
    "progressLabel": "{n} of {total}",
    "bonusNote": "Finish all three in a day for a bonus {n} Picks.",
    "difficulty": {
      "easy": "Easy",
      "medium": "Medium",
      "hard": "Hard"
    },
    "listLabel": "Today's quests"
  },
  "achievements": {
    "title": "Achievements",
    "waiting": "{n} ready to claim",
    "tierOf": "tier {tier} of {top}",
    "toNext": "Next at {n}",
    "complete": "Every tier earned",
    "maxed": "{n} — the top tier",
    "claimN": "Claim {n} tier(s) · {gems} Picks",
    "claimed": "+{gems} Picks",
    "claimedWithItem": "+{gems} Picks and something to wear",
    "claimFailed": "Could not claim: {why}",
    "category": {
      "habit": "Habit",
      "learning": "Learning",
      "playing": "Playing",
      "competition": "Together",
      "collection": "Collection"
    }
  },
  "streak": {
    "title": "Streak",
    "days": "day streak",
    "best": "Your best is {n}",
    "calendarLabel": "Days practiced this month",
    "previousMonth": "Previous month",
    "nextMonth": "Next month",
    "dayPracticed": "{date}: practiced",
    "dayMissed": "{date}: no session",
    "restDay": "Rest day",
    "restDayAvailable": "One missed day a week never breaks a streak. Yours is available — on the house, nothing to buy.",
    "restDayUsed": "You took this week's rest day. Another comes round seven days after it.",
    "milestones": "Milestones",
    "nextMilestone": "{days} more days to {n}, worth {gems} Picks.",
    "allMilestones": "Every milestone reached. Remarkable.",
    "society": "Miss two days in a row and the streak starts again from one. That is all that happens: there is nothing to buy back.",
    "dayStreak": "day streak",
    "milestoneReached": "{n} day streak reached",
    "milestoneBody": "You have practiced {n} days in a row. That is the habit, not the effort."
  },
  "shop": {
    "title": "Shop",
    "intro": "Everything here is for your companion to wear. Picks come from practicing: a lesson's first crown, quests, achievements and milestones.",
    "tab": {
      "wardrobe": "Wardrobe"
    },
    "owned": "Owned",
    "buyLabel": "Buy {name} for {picks} Picks",
    "confirmTitle": "Confirm",
    "confirmBuy": "Buy it",
    "leaving": "leaving {n}",
    "bought": "{name} is yours",
    "buyFailed": "Could not buy it: {why}",
    "needOnline": "Buying needs a connection — Picks are kept on the server.",
    "chestsWaiting": "{n} gig bag(s) waiting",
    "openOne": "Open",
    "chestTitle": "A gig bag",
    "openChest": "Open it",
    "openFailed": "Could not open it: {why}",
    "rewardGems": "{n} Picks",
    "rewardCosmetic": "Something to wear",
    "reason": {
      "notEnoughPicks": "Not enough Picks yet.",
      "alreadyOwned": "You already have this one."
    }
  },
  "bond": {
    "unknown": "No such character",
    "level": "Bond level {n}",
    "maxed": "The highest bond there is",
    "toNext": "{n} to the next level",
    "meterLabel": "Your bond with {name}",
    "howToEarn": "{name}'s bond grows when you work in their subject — their lessons, their exercises, their instrument.",
    "rewards": "What {name} has for you",
    "noRewards": "Nothing to unlock here yet.",
    "yours": "Yours",
    "readyToClaim": "Unlocked — find it in the wardrobe",
    "atLevel": "At bond level {n}",
    "practiceWith": "Practice with {name}"
  },
  "wardrobe": {
    "title": "Wardrobe",
    "slotLabel": "What to change",
    "slot": {
      "hat": "Hat",
      "eyes": "Eyes",
      "neck": "Neck",
      "held": "Held",
      "outfit": "Outfit",
      "aura": "Aura",
      "skin": "Skin"
    },
    "surprise": "Dress them at random",
    "equip": "Wear it",
    "equipped": "Wearing",
    "nothingHere": "Nothing for this slot suits them yet.",
    "noPreview": "No preview",
    "bought": "{name} is yours",
    "buyFailed": "Could not buy it: {why}",
    "needOnline": "Buying needs a connection — Picks are kept on the server.",
    "lockedUnknown": "Earned, not bought",
    "fromAchievement": "{name}, tier {tier}",
    "fromAchievementTop": "The top tier of {name}",
    "fromStreak": "A {n}-day streak",
    "fromBond": "Bond level {n} with {name}",
    "fromEnsemble": "Twenty-six weeks of playing the set with your ensemble",
    "fromMonthly": "A monthly challenge",
    "fromCertificate": "The Master's certificate"
  },
  "chest": {
    "bronze": "bronze",
    "silver": "silver",
    "gold": "gold"
  },
  "reward": {
    "groupLabel": "Reward {n} of {total}",
    "next": "Nice",
    "levelTitle": "Level {n}!",
    "levelBody": "Harder questions, and more of them worth having.",
    "crownTitle": "Crown earned",
    "crownBody": "{n} on this lesson now.",
    "gemsTitle": "+{n} Picks",
    "gemsBody": "Spend them on your companion's wardrobe.",
    "streakTitle": "{n} day streak",
    "streakBody": "Come back tomorrow and it keeps going.",
    "goalTitle": "Daily goal met",
    "goalBody": "{n} XP, done for today.",
    "questDoneTitle": "Quest complete",
    "questMovedTitle": "Quest progress",
    "questProgress": "{name} — {n} of {total}",
    "questSeveral": "You moved {n} quests along.",
    "achievementTitle": "Achievement tier {n}",
    "chestTitle": "A gig bag",
    "chestBody": "A {kind} gig bag is waiting in the shop.",
    "bondTitle": "{name}: bond level {n}",
    "bondBody": "They have something for you in the wardrobe.",
    "levelWord": "Level"
  },
  "certificate": {
    "title": "Master's Certificate",
    "locked": "Pass the {n}-question exam at the end of Section 10 and your certificate appears here.",
    "toPath": "Back to the path",
    "share": "Share",
    "save": "Save",
    "saved": "Certificate saved.",
    "failed": "The certificate could not be created.",
    "earned": "Master of Music Theory. Your certificate is on your profile.",
    "earnedShort": "Master of Music Theory"
  },
  "pwa": {
    "updateReady": "A new version of Audigoal is ready.",
    "updateNow": "Update",
    "updateLater": "Later",
    "offlineReady": "Audigoal is ready to work offline.",
    "installTitle": "Put Audigoal on your home screen",
    "installBody": "Opens full screen, works offline, and keeps your place. Nothing else changes.",
    "installAction": "Add to home screen",
    "installLater": "Not now",
    "installed": "Added. Audigoal is on your home screen.",
    "iosTitle": "Add to your home screen",
    "iosIntro": "Safari does not ask, so it takes three taps:",
    "iosStep1": "Tap the Share button at the bottom of Safari.",
    "iosStep2": "Scroll down and tap “Add to Home Screen”.",
    "iosStep3": "Tap “Add”. Audigoal then opens like any other app."
  },
  "friends": {
    "title": "Friends",
    "searchLabel": "Find a friend by username",
    "searchPlaceholder": "username",
    "searchHint": "Type at least two letters.",
    "searching": "Looking…",
    "noResults": "Nobody by that name yet.",
    "follow": "Follow",
    "following": "Following",
    "unfollow": "Unfollow",
    "levelShort": "Level {n}",
    "thisWeek": "This week",
    "xpWeek": "{n} XP",
    "you": "you",
    "boardOnlyYou": "Just you so far",
    "boardOnlyYouBody": "Follow someone and their week shows up here next to yours.",
    "shareProfile": "Share your profile link",
    "shareText": "Practice music with me on Audigoal — I’m @{name}.",
    "linkCopied": "Link copied.",
    "offline": "Friends need an account",
    "offlineBody": "No backend is configured in this build, so there is nobody to find.",
    "minor": "Friends are switched off",
    "minorBody": "Social features are off for younger learners.",
    "needUsername": "Choose a username so friends can find you.",
    "chooseUsername": "Choose a username",
    "failed": "That did not work: {why}"
  },
  "user": {
    "notFound": "No one by that name",
    "notFoundBody": "Check the spelling, or ask them for their profile link.",
    "levelLine": "Level {n} · {xp} XP",
    "followers": "Followers",
    "followingCount": "Following",
    "skillsMastered": "Skills mastered",
    "songsMastered": "Songs at 3 stars",
    "memberSince": "Learning since {date}",
    "itsYou": "This is you.",
    "myProfile": "Go to my profile",
    "plays": "Plays {instrument}"
  },
  "privacy": {
    "consentTitle": "Help make Audigoal better?",
    "consentBody": "Anonymous usage data — which screens and exercise types get used — and a crash report when something breaks. Never what you play, never your microphone. You can change your mind any time in Settings.",
    "consentYes": "Yes, share it",
    "consentNo": "No thanks",
    "title": "Privacy policy",
    "updated": "Last updated {date}",
    "intro": "Audigoal teaches music by listening to you play. This page says exactly what that involves, in plain words.",
    "micTitle": "Your microphone",
    "micBody": "When you start a listening exercise, the app asks for the microphone and analyzes the sound on your device to find the notes you play. Audio is never recorded, never stored and never sent anywhere. What leaves the device is a result — which note, how far off, how long — and only if you have an account.",
    "calibrationTitle": "Calibration",
    "calibrationBody": "The microphone calibration measures your room and your device and keeps a few numbers (a noise floor, a delay) on this device only. It is not synced.",
    "accountTitle": "Your account",
    "accountBody": "You can use Audigoal without an account; progress then lives on this device. With an account, your progress, scores, streak, Picks and purchases are stored so you can continue on another device. The account holds an id, an email address if you gave one, a username if you chose one, and your learning data. Nothing is sold and nothing is shared with advertisers.",
    "analyticsTitle": "Usage data and crash reports",
    "analyticsBody": "Both are off until you say yes, and can be switched off again in Settings. Usage data is which screens and kinds of exercise get used, so difficulty can be tuned. A crash report is the error and the screen it happened on. Neither includes your answers, your audio or your identity.",
    "childrenTitle": "Younger learners",
    "childrenBody": "If you tell us you are under 13, social features (ensembles, friends, usernames) are switched off and usage data is never collected.",
    "rightsTitle": "Your data, your call",
    "rightsBody": "Settings → Account lets you download everything Audigoal holds about you as one file, and delete your account and all of its data. Deletion is immediate and permanent.",
    "thirdPartiesTitle": "Services we rely on",
    "thirdPartiesBody": "Accounts and data are held by Supabase. If you opt in, usage data goes to PostHog and crash reports to Sentry. Instrument sounds are downloaded from our own servers.",
    "contactTitle": "Questions",
    "contactBody": "Use the contact details on the store listing or the link below.",
    "contactAction": "Report a problem or ask a question"
  },
  "credits": {
    "title": "Credits & licenses",
    "intro": "Audigoal stands on other people’s work. This is who.",
    "sounds": "Instrument sounds",
    "soundsBody": "FluidR3_GM soundfont, rendered by the MIDI.js soundfonts project (MIT). Piano, nylon and steel guitar, ocarina, bass, strings and choir.",
    "fonts": "Typefaces",
    "fontsBody": "Fredoka and Nunito, under the SIL Open Font License 1.1.",
    "libraries": "Open-source libraries",
    "songs": "Songs",
    "songsBody": "Every song in the songbook is in the public domain worldwide; each entry names its composer and first publication. Arrangements are our own.",
    "license": "{name} — {license}"
  }
}
